import { render, staticRenderFns } from "./TabIntro.vue?vue&type=template&id=58f1d370&scoped=true"
import script from "./TabIntro.vue?vue&type=script&lang=js"
export * from "./TabIntro.vue?vue&type=script&lang=js"
import style0 from "./TabIntro.vue?vue&type=style&index=0&id=58f1d370&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f1d370",
  null
  
)

export default component.exports